import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ToastContext } from '#pplx/frontend/aether/toasts/context/ToastContext.js';
import { ToastStateProvider } from '#pplx/frontend/aether/toasts/internal/ToastStateProvider.js';
import { ToastStoreProvider } from '#pplx/frontend/aether/toasts/internal/ToastStoreProvider.js';
import { Dynamic } from '#pplx/frontend/dynamic/Dynamic.js';
import { memo, useContext } from 'react';
const DynamicGlobalToastRenderer = Dynamic(async () => {
    const { GlobalToastRenderer } = await import('#pplx/frontend/aether/toasts/render/GlobalToastRenderer.js');
    return { default: GlobalToastRenderer };
});
export const ToastProvider = memo(function ToastProvider({ children, render, renderer, inherit = true, }) {
    const inheritedToastContext = useContext(ToastContext);
    // The manager owner also owns presentation; nested render and renderer props are ignored.
    if (inheritedToastContext != null && inherit)
        return children;
    return (_jsx(ToastStoreProvider, { children: _jsxs(ToastStateProvider, { children: [children, render && _jsx(DynamicGlobalToastRenderer, { renderer: renderer })] }) }));
});
//# sourceMappingURL=ToastProvider.js.map